interface Action {
    payload: any,
    type: string
}

export interface User {
    first_name: string,
    last_name: string,
    business_name: string,
    email: string,
    phone: string,
    avatar?: string,
    id?: number,
    activated?: boolean,
    deleted?: boolean,
    paymentMethods?: any
}


const UserReducer = (state = {}, action: Action) => {
    switch (action.type) {
        case 'GET_USER_INFO':
            return action.payload;
        default:
            return state;
    }
};

export default UserReducer;
